import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePriceStore = defineStore(
  'priceSocket',
  () => {
    // 是否开盘
    const isOpen = ref(false)

    // 价格id
    const priceId = ref(null)

    // 盘面价格
    const goldPlate = reactive({
      huangJin: {},
      boJin: {},
      baJin: {},
      baiYin: {},
      shangJinSuo: {},
      guoJiXianHuo: {},
    })

    const setOpen = (value) => {
      isOpen.value = value
    }

    const setPriceId = (value) => {
      priceId.value = value
    }

    const setPrice = (resBody) => {
      for (const i in resBody) {
        if (resBody[i].name === '黄金') {
          for (const b in resBody[i].prices) {
            if (resBody[i].prices[b].display === 'SHOW') {
              const diff = resBody[i].prices[b].xiaoshou - resBody[i].prices[b].huigou

              const high = resBody[i].prices[b].high - diff
              const low = resBody[i].prices[b].low - diff

              goldPlate.huangJin[b] = {
                ...resBody[i].prices[b],
                huigou: resBody[i].prices[b].huigou.toFixed(2),
                high: (high || 0).toFixed(2),
                low: (low || 0).toFixed(2),
                color: getColor(
                  goldPlate.huangJin?.[b]?.huigou,
                  resBody[i].prices[b].huigou,
                  goldPlate.huangJin?.[b]?.color,
                ),
              }
            }
          }
        }
        if (resBody[i].name === '铂金') {
          for (const b in resBody[i].prices) {
            if (resBody[i].prices[b].display === 'SHOW') {
              const diff = resBody[i].prices[b].xiaoshou - resBody[i].prices[b].huigou
              const high = resBody[i].prices[b].high - diff
              const low = resBody[i].prices[b].low - diff
              goldPlate.boJin[b] = {
                ...resBody[i].prices[b],
                huigou: resBody[i].prices[b].huigou.toFixed(2),
                high: (high || 0).toFixed(2),
                low: (low || 0).toFixed(2),
                color: getColor(
                  goldPlate.boJin?.[b]?.huigou,
                  resBody[i].prices[b].huigou,
                  goldPlate.boJin?.[b]?.color,
                ),
              }
            }
          }
        }
        if (resBody[i].name === '钯金') {
          for (const b in resBody[i].prices) {
            if (resBody[i].prices[b].display === 'SHOW') {
              const diff = resBody[i].prices[b].xiaoshou - resBody[i].prices[b].huigou
              const high = resBody[i].prices[b].high - diff
              const low = resBody[i].prices[b].low - diff
              goldPlate.baJin[b] = {
                ...resBody[i].prices[b],
                huigou: resBody[i].prices[b].huigou.toFixed(2),
                high: (high || 0).toFixed(2),
                low: (low || 0).toFixed(2),
                color: getColor(
                  goldPlate.baJin?.[b]?.huigou,
                  resBody[i].prices[b].huigou,
                  goldPlate.baJin?.[b]?.color,
                ),
              }
            }
          }
        }
        if (resBody[i].name === '白银') {
          for (const b in resBody[i].prices) {
            if (resBody[i].prices[b].display === 'SHOW') {
              const diff = resBody[i].prices[b].xiaoshou - resBody[i].prices[b].huigou
              const high = resBody[i].prices[b].high - diff
              const low = resBody[i].prices[b].low - diff
              goldPlate.baiYin[b] = {
                ...resBody[i].prices[b],
                huigou: resBody[i].prices[b].huigou.toFixed(3),
                high: (high || 0).toFixed(3),
                low: (low || 0).toFixed(3),
                color: getColor(
                  goldPlate.baiYin?.[b]?.huigou,
                  resBody[i].prices[b].huigou,
                  goldPlate.baiYin?.[b]?.color,
                ),
              }
            }
          }
        }
        if (resBody[i].name === '上金所') {
          for (const b in resBody[i].prices) {
            if (resBody[i].prices[b].display === 'SHOW') {
              goldPlate.shangJinSuo[b] = {
                ...resBody[i].prices[b],
                color: getColor(
                  goldPlate.shangJinSuo?.[b]?.huigou,
                  resBody[i].prices[b].huigou,
                  goldPlate.shangJinSuo?.[b]?.color,
                ),
                xsColor: getColor(
                  goldPlate.shangJinSuo?.[b]?.xiaoshou,
                  resBody[i].prices[b].xiaoshou,
                  goldPlate.shangJinSuo?.[b]?.xsColor,
                ),
              }
            }
          }
        }
        if (resBody[i].name === '国际现货') {
          for (const b in resBody[i].prices) {
            if (resBody[i].prices[b].display === 'SHOW') {
              goldPlate.guoJiXianHuo[b] = {
                ...resBody[i].prices[b],
                color: getColor(
                  goldPlate.guoJiXianHuo?.[b]?.huigou,
                  resBody[i].prices[b].huigou,
                  goldPlate.guoJiXianHuo?.[b]?.color,
                ),
                xsColor: getColor(
                  goldPlate.shangJinSuo?.[b]?.xiaoshou,
                  resBody[i].prices[b].xiaoshou,
                  goldPlate.shangJinSuo?.[b]?.xsColor,
                ),
              }
            }
          }
        }
      }
    }

    const getColor = (oldV, newV, color) => {
      if (color) {
        if (Number(oldV || 0) === Number(newV || 0)) return color
        return Number(oldV || 0) < Number(newV || 0) ? '#FD332C' : '#12913E'
      }
      return '#FD332C'
    }

    return {
      isOpen,
      goldPlate,
      priceId,
      setOpen,
      setPrice,
      setPriceId,
    }
  },
  {
    persist: true,
  },
)
